/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { SortedHeader } from "components/Datatable/components/SortedHeader";
import { formatToBRL } from "@/pages/conciliation/stores/utils/formatToMoney";

export const columns = [
  {
    accessorKey: "name",
    header: () => (
      <div className="flex gap-4 w-full items-center justify-start">Nome</div>
    ),
  },
  {
    accessorKey: "operator",
    header: () => (
      <div className="flex gap-4 w-full items-center justify-start">
        Operador
      </div>
    ),
  },
  //TODO: Verificar campo caixa
  {
    accessorKey: "register_code",
    header: () => (
      <div className="flex gap-4 w-full items-center justify-start">Caixa</div>
    ),
  },
  {
    id: "amount",
    header: () => (
      <div className="flex gap-4 w-full items-center justify-center">Valor</div>
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div className={`w-full flex items-center justify-end`}>
          {formatToBRL(+row?.original?.amount)}
        </div>
      );
    },
    className: "w-[128px] items-center justify-end",
  },
];
